<template>
  <Teleport to="body">
    <Transition name="guest-limit">
      <div v-if="authStore.showGuestLimit" class="fixed inset-0 z-[120] flex items-end justify-center" @click.self="close">
        <!-- Backdrop -->
        <div class="absolute inset-0 bg-black/40" @click="close" />

        <!-- Bottom sheet -->
        <div class="relative w-full max-w-[430px] bg-cream rounded-t-3xl px-6 pt-6 pb-sheet-8 z-10">
          <!-- Close button -->
          <button @click="close" class="absolute top-4 right-4 p-1">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2.5" stroke-linecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>

          <!-- Icon -->
          <div class="flex justify-center mb-4">
            <div class="w-14 h-14 rounded-full bg-ink/10 flex items-center justify-center">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
          </div>

          <!-- Заголовок общий для обоих случаев: дневной лимит токенов
               (обнулится в 5:00) и крыша числа вызовов гостя -->
          <h2 class="text-xl font-bold text-center text-ink mb-2">Пробный лимит на сегодня исчерпан</h2>
          <p class="text-sm text-center text-ink/70 mb-6 leading-relaxed">
            Зарегистрируйтесь, чтобы продолжить<br>
            пользоваться Зоей. Это займёт меньше минуты.
          </p>

          <!-- Buttons -->
          <div class="flex gap-3">
            <button
              @click="close"
              class="flex-1 py-3 rounded-xl text-sm font-medium text-ink bg-ink/10 active:bg-ink/20 transition-colors"
            >
              Позже
            </button>
            <button
              @click="register"
              class="flex-1 py-3 rounded-xl text-sm font-medium text-white bg-ink active:bg-[#2a1a10] transition-colors"
            >
              Зарегистрироваться
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { watch, onUnmounted } from 'vue'
import { useAuthStore } from '../store/auth.js'
import { track } from '../analytics.js'
import { reportPaywallEvent } from '../services/paywallEvents.js'

const authStore = useAuthStore()

let savedScrollY = 0

watch(() => authStore.showGuestLimit, (val) => {
  if (val) {
    reportPaywallEvent('guest', 'shown')
    track('guest_limit_popup_shown')
    savedScrollY = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.overflow = ''
    window.scrollTo(0, savedScrollY)
  }
})

onUnmounted(() => {
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.overflow = ''
})

function close() {
  reportPaywallEvent('guest', 'close')
  authStore.showGuestLimit = false
}

function register() {
  reportPaywallEvent('guest', 'register')
  authStore.showGuestLimit = false
  authStore.openAuthPopup()
}
</script>

<style scoped>
.guest-limit-enter-active,
.guest-limit-leave-active {
  transition: opacity 0.3s ease;
}
.guest-limit-enter-active .relative,
.guest-limit-leave-active .relative {
  transition: transform 0.3s ease;
}
.guest-limit-enter-from,
.guest-limit-leave-to {
  opacity: 0;
}
.guest-limit-enter-from .relative {
  transform: translateY(100%);
}
.guest-limit-leave-to .relative {
  transform: translateY(100%);
}
</style>
